// PJ-3 / B1 — Campo de fútbol vertical con la posición PRINCIPAL (punto
// destacado) y la SECUNDARIA (punto tenue). SVG puro (sin recharts). Espejo
// geométrico del SVG del PDF (app/src/lib/pdf/evaluationHtml.ts) y del FieldPitch
// de la app: viewBox 100×150, x = pos.x, y = pos.y * 1.5 (GK abajo, ataque arriba).

import { fieldPositionByKey, type FieldPosition } from '../lib/fieldPositions';

interface Props {
  primary: string | null;
  secondary: string | null;
  width?: number;
}

const FILL = '#15331F';
const LINE = '#3C6B49';
const GOLD = '#FFF200';

function Dot({ pos, primary }: { pos: FieldPosition; primary: boolean }) {
  const cx = pos.x;
  const cy = pos.y * 1.5;
  const r = primary ? 5.5 : 4.5;
  return (
    <g>
      <circle
        cx={cx}
        cy={cy}
        r={r}
        fill={primary ? GOLD : `${GOLD}33`}
        stroke={GOLD}
        strokeWidth={primary ? 0.6 : 0.8}
        strokeOpacity={primary ? 1 : 0.7}
      />
      <text
        x={cx}
        y={cy + 1.7}
        fontSize={primary ? 4 : 3.4}
        fill={primary ? '#000' : GOLD}
        textAnchor="middle"
        fontWeight={700}
      >
        {pos.abbr}
      </text>
    </g>
  );
}

export default function FieldPitch({ primary, secondary, width = 150 }: Props) {
  const p = fieldPositionByKey(primary);
  const s = fieldPositionByKey(secondary);
  return (
    <svg
      data-testid="field-pitch"
      data-primary={primary ?? ''}
      data-secondary={secondary ?? ''}
      width={width}
      viewBox="0 0 100 150"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x={0} y={0} width={100} height={150} fill={FILL} rx={2} />
      {/* Líneas del campo */}
      <rect x={2} y={2} width={96} height={146} fill="none" stroke={LINE} strokeWidth={0.8} />
      <line x1={2} y1={75} x2={98} y2={75} stroke={LINE} strokeWidth={0.8} />
      <circle cx={50} cy={75} r={11} fill="none" stroke={LINE} strokeWidth={0.8} />
      <circle cx={50} cy={75} r={0.9} fill={LINE} />
      <rect x={26} y={2} width={48} height={20} fill="none" stroke={LINE} strokeWidth={0.8} />
      <rect x={39} y={2} width={22} height={8} fill="none" stroke={LINE} strokeWidth={0.8} />
      <rect x={26} y={128} width={48} height={20} fill="none" stroke={LINE} strokeWidth={0.8} />
      <rect x={39} y={140} width={22} height={8} fill="none" stroke={LINE} strokeWidth={0.8} />
      {/* Secundaria primero (debajo); principal encima si solapan */}
      {s && <Dot pos={s} primary={false} />}
      {p && <Dot pos={p} primary />}
    </svg>
  );
}
